module.exports = __webpack_public_path__ + "img/Bidvest_Bank_Logo.d29cd2fb.svg";